import { apiService } from './apiService';
import { Feedback, FeedbackCreate } from '../types/feedback';

class FeedbackService {
  async create(data: FeedbackCreate): Promise<Feedback> {
    const response = await apiService.post<Feedback>('/feedback', data);
    return response.data;
  }

  async listMine(): Promise<Feedback[]> {
    const response = await apiService.get<Feedback[]>('/feedback');
    return response.data;
  }
}

export const feedbackService = new FeedbackService();
